// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1XG_V","label":"Completed_label__MYt6d"};